import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

interface TopBarStore {
  title: string;
  subtitle?: string;
  color: 'primary' | 'workorder';
  guideSubjectId: string;
  setTopBar: (topBar: {
    title: string;
    subtitle?: string;
    color: 'primary' | 'workorder';
    guideSubjectId: string;
  }) => void;
}

export const useTopBar = create<TopBarStore>()(
  devtools(
    (set) => ({
      title: 'HållKoll',
      color: 'primary',
      guideSubjectId: '',
      setTopBar: ({ title, subtitle, color, guideSubjectId }) => {
        set(() => ({
          title,
          subtitle,
          color,
          guideSubjectId,
        }));
      },
    }),
    { name: 'topbar-store', enabled: process.env.NODE_ENV !== 'test' },
  ),
);
